import type { TranslateDictionary } from './en.js';

export const Sk: TranslateDictionary = {
  'Start airplay': 'Spustiť AirPlay',
  'Stop airplay': 'Zastaviť AirPlay',
  Audio: 'Audio',
  Captions: 'Titulky',
  'Enable captions': 'Povoliť titulky',
  'Disable captions': 'Zakázať titulky',
  'Start casting': 'Spustiť prenos',
  'Stop casting': 'Zastaviť prenos',
  'Casting to {device}': 'Prenášanie do {device}',
  'Enter fullscreen mode': 'Zapnúť na celú obrazovku',
  'Exit fullscreen mode': 'Ukončiť prehrávanie na celú obrazovku',
  Mute: 'Stlmiť',
  Unmute: 'Odtlmiť',
  'Enter picture in picture mode': 'Zapnúť režim obraz-v-obraze',
  'Exit picture in picture mode': 'Vypnúť režim obraz-v-obraze',
  Play: 'Prehrať',
  Pause: 'Pozastaviť',
  'Playback rate': 'Rýchlosť prehrávania',
  'Playback rate {playbackRate}': 'Rýchlosť prehrávania {playbackRate}',
  Quality: 'Kvalita',
  'Seek backward': 'Pretočiť dozadu',
  'Seek forward': 'Pretočiť dopredu',
  Settings: 'Nastavenia',
  Auto: 'Auto',
  'audio player': 'audio prehrávač',
  'video player': 'video prehrávač',
  volume: 'Hlasitosť',
  seek: 'Hľadať',
  'closed captions': 'Titulky',
  'current playback rate': 'aktuálna rýchlosť prehrávania',
  'playback time': 'čas prehrávania',
  'media loading': 'načítavanie médií',
  settings: 'Nastavenia',
  'audio tracks': 'audio stopy',
  quality: 'Kvalita',
  play: 'prehrať',
  pause: 'pozastaviť',
  mute: 'stlmiť',
  unmute: 'odtlmiť',
  'chapter: {chapterName}': 'kapitola: {chapterName}',
  live: 'naživo',
  Off: 'Vypnuté',
  'start airplay': 'spustiť AirPlay',
  'stop airplay': 'zastaviť AirPlay',
  'start casting': 'spustiť prenos',
  'stop casting': 'zastaviť prenos',
  'enter fullscreen mode': 'zapnúť na celú obrazovku',
  'exit fullscreen mode': 'ukončiť prehrávanie na celú obrazovku',
  'enter picture in picture mode': 'zapnúť režim obraz-v-obraze',
  'exit picture in picture mode': 'vypnúť režim obraz-v-obraze',
  'seek to live': 'prejsť na živé vysielanie',
  'playing live': 'prehrávanie naživo',
  'seek back {seekOffset} seconds': 'pretočiť dozadu {seekOffset} sekúnd',
  'seek forward {seekOffset} seconds': 'pretočiť dopredu {seekOffset} sekúnd',
  'Network Error': 'Chyba siete',
  'Decode Error': 'Chyba dekódovania',
  'Source Not Supported': 'Zdroj nie je podporovaný',
  'Encryption Error': 'Chyba šifrovania',
  'A network error caused the media download to fail.':
    'Chyba siete spôsobila zlyhanie sťahovania médií.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Chyba médií spôsobila prerušenie prehrávania. Médiá môžu byť poškodené alebo váš prehliadač nepodporuje tento formát.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Došlo k nepodporovanej chybe. Server alebo sieť zlyhali, alebo váš prehliadač nepodporuje tento formát.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Médiá sú šifrované a neexistujú žiadne kľúče na ich dešifrovanie.',
  'This video is not available.': 'Toto video nie je k dispozícii.',
  'This video could not be found.': 'Toto video sa nepodarilo nájsť.',
};
